import { InputSelectComboboxStandardItemWrapper } from '@npco/zeller-design-system'
import styled from 'styled-components'

export const StyledItemWrapper = styled(InputSelectComboboxStandardItemWrapper)`
  display: flex;
  flex-direction: row;
`
